/* eslint-disable max-len */
import { Text, Box } from '@chakra-ui/react';
import { parseISO, format } from 'date-fns';
import { PopoverTag } from '@acp/core-ui';
import { ReportedFindingData } from '@acp/shared';

export function QuoteRequestedTag({
    reportedFinding,
}: {
    reportedFinding: ReportedFindingData;
}) {
    if (reportedFinding.problemRegister?.quoteRequested !== true) {
        return null;
    }

    return (
        <Box mt={1}>
            <PopoverTag
                popoverPlacement="auto"
                colorScheme="blackAlpha"
                title="Quote requested"
            >
                <Text fontSize="small">
                    Quote requested by
                    {' '}
                    {reportedFinding.problemRegister?.quoteRequestedBy ?? ''}
                </Text>
                <Text fontSize="small">
                    {reportedFinding.problemRegister?.dateQuoteRequested != null
                        ? format(
                            parseISO(reportedFinding.problemRegister.dateQuoteRequested),
                            "d/M/yyyy 'at' h:mmaaa"
                        )
                        : ''}
                </Text>
            </PopoverTag>
        </Box>
    );
}
